module.exports = __webpack_public_path__ + "img/eirin yagokoro_sc1.cda2b66b.png";